export default __webpack_public_path__ + "static/media/grad2.6d3c1190.png";